import { useState } from 'react'
import { User, Lock, Shield, Monitor } from '@werkstatt/ui'
import { useAuthStore } from '../../contexts/authStore'
import CustomerProfileTab from './account/CustomerProfileTab'
import CustomerSecurityTab from './account/CustomerSecurityTab'
import CustomerTwoFactorTab from './account/CustomerTwoFactorTab'
import CustomerSessionsPanel from './account/CustomerSessionsPanel'

const tabs = [
  { key: 'profile', label: 'Profil', icon: User },
  { key: 'security', label: 'Sicherheit', icon: Lock },
  { key: '2fa', label: '2FA', icon: Shield },
  { key: 'sessions', label: 'Sitzungen', icon: Monitor },
] as const

type TabKey = (typeof tabs)[number]['key']

export default function CustomerAccountPage() {
  const [activeTab, setActiveTab] = useState<TabKey>('profile')
  const { user } = useAuthStore()

  return (
    <div>
      <div style={{ marginBottom: 32 }}>
        <h1 style={{ fontSize: 26, margin: '0 0 6px' }}>Kontoeinstellungen</h1>
        <p className="wc-muted" style={{ fontSize: 14, margin: 0 }}>
          Verwalten Sie Ihr Profil, Sicherheitseinstellungen und mehr
        </p>
      </div>

      <div className="wc-card wc-elev-sm" style={{ marginBottom: 24 }}>
        <h3 className="wc-card-title">Kontoinformationen</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 16 }}>
          <div>
            <p className="wc-muted" style={{ fontSize: 12, margin: '0 0 2px' }}>E-Mail</p>
            <p style={{ margin: 0, fontSize: 14 }}>{user?.email}</p>
          </div>
          <div>
            <p className="wc-muted" style={{ fontSize: 12, margin: '0 0 2px' }}>Benutzertyp</p>
            <p style={{ margin: 0, fontSize: 14 }}>Kunde</p>
          </div>
        </div>
      </div>

      <div className="wc-seg" style={{ marginBottom: 20, display: 'flex', width: '100%' }}>
        {tabs.map((tab) => {
          const Icon = tab.icon
          return (
            <button
              key={tab.key}
              type="button"
              onClick={() => setActiveTab(tab.key)}
              className="wc-seg-opt"
              aria-pressed={activeTab === tab.key}
              style={{ flex: 1, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}
            >
              <Icon size={14} />
              {tab.label}
            </button>
          )
        })}
      </div>

      <div>
        {activeTab === 'profile' && <CustomerProfileTab />}
        {activeTab === 'security' && <CustomerSecurityTab />}
        {activeTab === '2fa' && <CustomerTwoFactorTab />}
        {activeTab === 'sessions' && <CustomerSessionsPanel />}
      </div>
    </div>
  )
}
